<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M13.5344 6.4681L12.0311 10.9773C11.9493 11.2228 11.8114 11.4458 11.6285 11.6288C11.4455 11.8118 11.2224 11.9496 10.9769 12.0314L6.46777 13.5348L7.97111 9.0256C8.05293 8.78012 8.19078 8.55705 8.37375 8.37408C8.55672 8.19111 8.77979 8.05325 9.02527 7.97143L13.5344 6.4681Z"
			:fill="computedFill"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M10.0003 18.3333C14.6027 18.3333 18.3337 14.6024 18.3337 10C18.3337 5.39762 14.6027 1.66666 10.0003 1.66666C5.39795 1.66666 1.66699 5.39762 1.66699 10C1.66699 14.6024 5.39795 18.3333 10.0003 18.3333Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M9.99967 10.4167C10.2298 10.4167 10.4163 10.2301 10.4163 10C10.4163 9.76988 10.2298 9.58334 9.99967 9.58334C9.76956 9.58334 9.58301 9.76988 9.58301 10C9.58301 10.2301 9.76956 10.4167 9.99967 10.4167Z"
			:fill="computedStroke"
			:stroke="computedStroke"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconAdvisor',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: '#BBCA4A'
		},
		filled: {
			type: Boolean,
			default: false
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.3
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
